export const ItemTypes = [
  {
    id: 1,
    name: "IMU sensors",
  },
  {
    id: 2,
    name: "Temperature sensor",
  },
  {
    id: 3,
    name: "Humidity sensor",
  },
  {
    id: 4,
    name: "Pressure sensor",
  },
  {
    id: 5,
    name: "Duct Smoke Detectors",
  },
  {
    id: 6,
    name: "Filter Differential Pressure Sensors",
  },
  {
    id: 7,
    name: "Vibration Sensors",
  },
  {
    id: 8,
    name: "Occupancy Sensors",
  },
  {
    id: 9,
    name: "CO2 Sensors",
  },
  {
    id: 10,
    name: "Power Monitoring Sensors",
  },
  {
    id: 11,
    name: "Voltage Monitoring Sensors",
  },
  {
    id: 12,
    name: "Current Monitoring Sensors",
  },
  {
    id: 13,
    name: "Active Power Observer",
  },
  {
    id: 14,
    name: "Reactive Power Observer",
  },
  {
    id: 15,
    name: "Asset Total Power",
  },
];

export const roles = [
  {
    id: "1",
    name: "Admin",
  },
  {
    id: "2",
    name: "Facility Manager",
  },
  {
    id: "3",
    name: "Maintenance Officer",
  },
  {
    id: "4",
    name: "Business Purpose User",
  },
];

export const AssetTypes = [
  {
    id: 1,
    name: "Building in",
  },
  {
    id: 2,
    name: "Building out",
  },
  {
    id: 3,
    name: "Terrace",
  },
];

export const AlarmStatusType = [
  {
    id: 0,
    name: "NONE",
  },
  {
    id: 1,
    name: "LOW",
  },
  {
    id: 2,
    name: "MEDIUM",
  },
  {
    id: 3,
    name: "HIGH",
  },
  {
    id: 4,
    name: "CRITICAL",
  },
];

export const assetProtocols = [
  {
    id: "MQTT",
    name: "MQTT",
  },
  {
    id: "BACnet",
    name: "BACnet",
  },
  {
    id: "Modbus",
    name: "Modbus",
  },
  {
    id: "LoRa",
    name: "LoRa",
  },
  {
    id: "OPC UA",
    name: "OPC UA",
  },
  {
    id: "DNP3",
    name: "DNP3",
  },
  {
    id: "EtherCAT",
    name: "EtherCAT",
  },
  {
    id: "PROFINET",
    name: "PROFINET",
  },
  {
    id: "HART",
    name: "HART",
  },
  {
    id: "CANopen",
    name: "CANopen",
  },
  {
    id: "Z-Wave",
    name: "Z-Wave",
  },
  {
    id: "Bluetooth Low Energy (BLE)",
    name: "Bluetooth Low Energy (BLE)",
  },
  {
    id: "Zigbee",
    name: "Zigbee",
  },
];

export const ticketImpacts = [
  { id: 1, name: "Low" },
  { id: 2, name: "Medium" },
  { id: 3, name: "High" },
  { id: 4, name: "Critical" },
];

export const ticketStatuses = [
  { id: 1, name: "Open" },
  { id: 2, name: "In progress" },
  { id: 3, name: "Pending approval" },
  { id: 4, name: "Closed" },
];

export const TicketStatus = {
  OPEN: "Open",
  INPROGRESS: "In progress",
  PENDINGAPPROVAL: "Pending approval",
  CLOSED: "Closed",
};

export const ReportsColumnFields = {
  SITE: "site",
  TICKET: "ticket",
  TIMESPENT: "timeSpent",
  COST: "cost",
};

export default ItemTypes;

export const ContractTypes = [
  {
    id: 1,
    name: "Onerous Contract",
  },
  {
    id: 2,
    name: "Periodic Maintenance Contract",
  },
];
